import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Seja bem vindo a nosso APP", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Clique no botão abaixo para iniciar", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Horários para pedidos: ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Segunda a Sábado das 8:00 as 15:00", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Domingos das 8:00 até as 13:00", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Pedidos feitos após o horário final serão agendados para o dia seguinte.", -1)

import { IonPage, IonHeader, IonToolbar, IonTitle, IonButton, IonContent, IonGrid, IonRow, IonCol, IonImg } from '@ionic/vue';
// import { ref, reactive , onMounted } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeIntro',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), { color: "danger" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("Bem vindo")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { class: "ion-padding" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonGrid), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonImg), {
                        src: "../img/uniboi_logo.png",
                        alt: "Logo Uniboi"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), null, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), null, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol)),
                  _createVNode(_unref(IonCol), null, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, { to: "/tabs/menu" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonButton), {
                            class: "hb1",
                            expand: "block"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Acessar o APP")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonCol))
                ]),
                _: 1
              }),
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), null, {
                    default: _withCtx(() => [
                      _hoisted_3,
                      _hoisted_4,
                      _hoisted_5,
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})